// Barra progresiva de descuento por cantidad dentro del carrito de UpCart (estilo liviacorsini.it).
// Escalones = descuentos automáticos de la tienda: 2 artículos 15 %, 3 artículos 20 %, 4 artículos 25 %.
(function () {
  var TIERS = [{ qty: 2, pct: 15 }, { qty: 3, pct: 20 }, { qty: 4, pct: 25 }];
  var count = null;
  var timer = null;

  function message(n) {
    var reached = null, next = null;
    TIERS.forEach(function (t) { if (n >= t.qty) reached = t; else if (!next) next = t; });
    if (!next) return reached.pct + ' % de réduction appliqués';
    var missing = next.qty - n;
    var add = reached
      ? 'Ajoutez ' + missing + ' article' + (missing > 1 ? 's' : '') + ' de plus et obtenez ' + next.pct + ' %'
      : (n === 0
        ? 'Ajoutez ' + missing + ' articles et obtenez ' + next.pct + ' % de réduction'
        : 'Ajoutez ' + missing + ' article' + (missing > 1 ? 's' : '') + ' de plus et obtenez ' + next.pct + ' % de réduction');
    return reached ? reached.pct + ' % appliqués · ' + add : add;
  }

  function progress(n) {
    for (var i = 0; i < TIERS.length; i++) if (n < TIERS[i].qty) return Math.min(n / TIERS[i].qty * 100, 100);
    return 100;
  }

  // Inserta la barra justo debajo de la cabecera del carrito; UpCart re-pinta su panel, así que se vuelve a poner si desaparece
  function ensureBar() {
    var header = document.querySelector('#upCart .upcart-public-header');
    if (!header) return null;
    var anchor = header.parentElement;
    var bar = document.getElementById('cfRewardBar');
    if (bar && bar.previousElementSibling === anchor) return bar;
    if (bar) bar.remove();
    bar = document.createElement('div');
    bar.id = 'cfRewardBar';
    bar.className = 'cf-reward-bar';
    bar.innerHTML = '<p class="cf-reward-message"></p><div class="cf-reward-track"><div class="cf-reward-progress"></div></div>';
    anchor.insertAdjacentElement('afterend', bar);
    return bar;
  }

  function render() {
    var bar = ensureBar();
    if (!bar || count === null) return;
    var msg = message(count);
    var w = progress(count).toFixed(2) + '%';
    var m = bar.querySelector('.cf-reward-message');
    var p = bar.querySelector('.cf-reward-progress');
    if (m.textContent !== msg) m.textContent = msg;
    if (p.style.width !== w) p.style.width = w;
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { count = cart.item_count; render(); })
      .catch(function () {});
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(refresh, 250); }

  // Cualquier cambio del carrito (añadir, quitar, cambiar cantidad) pasa por /cart/...
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var res = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) res.then(schedule, schedule);
      return res;
    };
  }
  document.addEventListener('cart:updated', schedule);

  function start() {
    refresh();
    var root = document.getElementById('upCart') || document.body;
    new MutationObserver(function (muts) {
      // ignorar los cambios de la propia barra para no entrar en bucle
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!(t.closest && t.closest('#cfRewardBar'))) { render(); schedule(); return; }
      }
    }).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
